(function () {
  function formatIndianPrice(cents) {
    var amount = (Number(cents) || 0) / 100;

    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0
    }).format(amount);
  }

  function formatPackagePrices(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-at-price]')) {
      var rootCents = scope.dataset.atPrice;

      if (rootCents) {
        scope.textContent = '₹ ' + formatIndianPrice(rootCents);
      }
    }

    if (!scope.querySelectorAll) return;

    scope
      .querySelectorAll('[data-at-price]')
      .forEach(function (element) {
        var cents = element.dataset.atPrice;

        if (!cents) return;

        element.textContent = '₹ ' + formatIndianPrice(cents);
      });
  }

  var stickyCounter = 0;
  var stickyWaitAttempts = 0;
  var stickyWaitFrame = null;

  function updateBudgetFields(select) {
    var form = select.closest('form');
    if (!form) return;

    var minInput = form.querySelector('[data-at-budget-min]');
    var maxInput = form.querySelector('[data-at-budget-max]');
    var values = String(select.value || '|').split('|');

    if (minInput) minInput.value = values[0] || '';
    if (maxInput) maxInput.value = values[1] || '';
  }

  function initialiseBudgetSelect(select) {
    if (select.dataset.atBudgetReady === 'true') return;

    select.dataset.atBudgetReady = 'true';

    updateBudgetFields(select);

    select.addEventListener('change', function () {
      updateBudgetFields(select);
    });
  }

  function getCollectionRoots(scope) {
    var roots = [];
    var currentScope = scope || document;

    function add(root) {
      if (root && roots.indexOf(root) === -1) {
        roots.push(root);
      }
    }

    if (
      currentScope.matches &&
      currentScope.matches('[data-at-package-collection]')
    ) {
      add(currentScope);
    }

    if (currentScope.closest) {
      add(
        currentScope.closest('[data-at-package-collection]')
      );
    }

    if (currentScope.querySelectorAll) {
      currentScope
        .querySelectorAll('[data-at-package-collection]')
        .forEach(add);
    }

    return roots;
  }

  function getStickyTop() {
    var headerHeight = parseFloat(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--header-group-height')
    );

    return (
      (Number.isFinite(headerHeight) ? headerHeight : 90) + 20
    );
  }

  function scheduleStickyRetry() {
    if (
      stickyWaitFrame ||
      stickyWaitAttempts >= 180
    ) {
      return;
    }

    stickyWaitFrame = requestAnimationFrame(function () {
      stickyWaitFrame = null;
      stickyWaitAttempts += 1;

      initialiseStickyWithin(document);
    });
  }

  function initialiseFilterSticky(collectionRoot) {
    if (!window.gsap || !window.ScrollTrigger) {
      scheduleStickyRetry();
      return;
    }

    var layout = collectionRoot.querySelector(
      '.at-package-results-layout'
    );

    var filter = collectionRoot.querySelector(
      '.at-package-filter--desktop'
    );

    if (!layout || !filter) return;

    window.gsap.registerPlugin(window.ScrollTrigger);

    collectionRoot.atPackageFilterStickyCleanup?.();

    if (!collectionRoot.dataset.atStickyId) {
      stickyCounter += 1;

      collectionRoot.dataset.atStickyId =
        'at-package-filter-sticky-' + stickyCounter;
    }

    var triggerId =
      collectionRoot.dataset.atStickyId;

    window.ScrollTrigger
      .getById(triggerId)
      ?.kill(true);

    var mediaQuery = window.gsap.matchMedia();

    mediaQuery.add('(min-width: 990px)', function () {
      var getDistance = function () {
        return Math.max(
          0,
          layout.offsetHeight - filter.offsetHeight
        );
      };

      window.gsap.set(filter, {
        y: 0,
        willChange: 'transform'
      });

      var tween = window.gsap.to(filter, {
        y: function () {
          return getDistance();
        },

        ease: 'none',

        scrollTrigger: {
          id: triggerId,

          trigger: layout,

          start: function () {
            return (
              'top top+=' +
              getStickyTop()
            );
          },

          end: function () {
            return (
              '+=' +
              Math.max(
                1,
                getDistance()
              )
            );
          },

          scrub: true,

          invalidateOnRefresh: true
        }
      });

      var refresh = function () {
        window.ScrollTrigger.refresh();
      };

      var images =
        layout.querySelectorAll('img');

      var resizeObserver = null;

      images.forEach(function (image) {
        if (!image.complete) {
          image.addEventListener(
            'load',
            refresh,
            { once: true }
          );
        }
      });

      if ('ResizeObserver' in window) {
        resizeObserver =
          new ResizeObserver(refresh);

        resizeObserver.observe(layout);
        resizeObserver.observe(filter);
      }

      requestAnimationFrame(refresh);

      return function () {
        images.forEach(function (image) {
          image.removeEventListener(
            'load',
            refresh
          );
        });

        resizeObserver?.disconnect();

        tween.scrollTrigger?.kill(true);
        tween.kill();

        window.gsap.set(filter, {
          clearProps:
            'transform,willChange'
        });
      };
    });

    collectionRoot.atPackageFilterStickyCleanup =
      function () {
        mediaQuery.revert();

        delete collectionRoot
          .atPackageFilterStickyCleanup;
      };
  }

  function initialiseStickyWithin(scope) {
    getCollectionRoots(scope).forEach(
      initialiseFilterSticky
    );
  }

  function initialiseCollectionFaq(root) {
    if (
      root.dataset.atFaqReady === 'true'
    ) {
      return;
    }

    root.dataset.atFaqReady = 'true';

    root
      .querySelectorAll(
        '[data-at-collection-faq-item]'
      )
      .forEach(function (item) {
        var button = item.querySelector(
          '[data-at-collection-faq-toggle]'
        );

        var panel = item.querySelector(
          '[data-at-collection-faq-panel]'
        );

        if (!button || !panel) return;

        if (
          item.classList.contains('is-open')
        ) {
          panel.style.height = 'auto';
          panel.style.visibility = 'visible';
        }

        button.addEventListener(
          'click',
          function () {
            var opening =
              button.getAttribute(
                'aria-expanded'
              ) !== 'true';

            button.setAttribute(
              'aria-expanded',
              String(opening)
            );

            item.classList.toggle(
              'is-open',
              opening
            );

            panel.style.visibility =
              'visible';

            if (
              window.matchMedia(
                '(prefers-reduced-motion: reduce)'
              ).matches
            ) {
              panel.style.height =
                opening ? 'auto' : '0px';

              panel.style.visibility =
                opening
                  ? 'visible'
                  : 'hidden';

              return;
            }

            if (opening) {
              panel.style.height = '0px';

              requestAnimationFrame(
                function () {
                  panel.style.transition =
                    'height .38s cubic-bezier(.22,.61,.36,1)';

                  panel.style.height =
                    panel.scrollHeight + 'px';
                }
              );

              panel.addEventListener(
                'transitionend',
                function () {
                  panel.style.height =
                    'auto';

                  panel.style.transition =
                    '';
                },
                { once: true }
              );
            } else {
              panel.style.height =
                panel.scrollHeight + 'px';

              requestAnimationFrame(
                function () {
                  panel.style.transition =
                    'height .32s cubic-bezier(.4,0,.2,1)';

                  panel.style.height =
                    '0px';
                }
              );

              panel.addEventListener(
                'transitionend',
                function () {
                  panel.style.visibility =
                    'hidden';

                  panel.style.transition =
                    '';
                },
                { once: true }
              );
            }
          }
        );
      });
  }

  function initialise(root) {
    var scope = root || document;

    scope
      .querySelectorAll('[data-at-budget]')
      .forEach(initialiseBudgetSelect);

    scope
      .querySelectorAll(
        '[data-at-collection-faq]'
      )
      .forEach(initialiseCollectionFaq);

    /*
     * Format all package card prices
     * using Indian number grouping.
     */
    formatPackagePrices(scope);

    initialiseStickyWithin(scope);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initialise(document);
      }
    );
  } else {
    initialise(document);
  }

  window.addEventListener(
    'load',
    function () {
      window.ScrollTrigger?.refresh();
    },
    { once: true }
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialise(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      getCollectionRoots(
        event.target
      ).forEach(function (root) {
        root
          .atPackageFilterStickyCleanup
          ?.();
      });
    }
  );

  document.addEventListener(
    'shapes:section:hasmutated',
    function (event) {
      initialise(event.target);

      requestAnimationFrame(
        function () {
          window.ScrollTrigger?.refresh();
        }
      );
    }
  );
})();